// A. 读取 UTM 参数并持久化保存在 localStorage
function readUTMParams() {
    const params = new URLSearchParams(window.location.search);

    const utmSource   = params.get("utm_source")   || localStorage.getItem("utm_source")   || "";
    const utmMedium   = params.get("utm_medium")   || localStorage.getItem("utm_medium")   || "";
    const utmCampaign = params.get("utm_campaign") || localStorage.getItem("utm_campaign") || "";
    const utmContent  = params.get("utm_content")  || localStorage.getItem("utm_content")  || "";

    // 如果 URL 中带参数就更新 localStorage（写回）
    if (params.get("utm_source"))   localStorage.setItem("utm_source", utmSource);
    if (params.get("utm_medium"))   localStorage.setItem("utm_medium", utmMedium);
    if (params.get("utm_campaign")) localStorage.setItem("utm_campaign", utmCampaign);
    if (params.get("utm_content"))  localStorage.setItem("utm_content", utmContent);

    console.log("UTM 参数1:", { utmSource, utmMedium, utmCampaign, utmContent });

    return { utmSource, utmMedium, utmCampaign, utmContent };
}

let UTM_GLOBAL = {};

document.addEventListener("DOMContentLoaded", () => {
    UTM_GLOBAL = readUTMParams();
});



async function clientsMessageUpdate(fileReqParams) {
    const ipUrl = "https://www.lcsigner.cn/userForm";

    const { utmSource, utmMedium, utmCampaign, utmContent } =  UTM_GLOBAL;
    const InfoReqParams = {
        // --- UTM 参数 ---
        utmSource:utmSource || "none",
        utmMedium:utmMedium || "none",
        utmCampaign:utmCampaign || "none",
        utmContent:utmContent || "none",
        firstNameMas: fileReqParams.firstNameMas || "none",
        lastNameMas: fileReqParams.lastNameMas || "none",
        emailMas: fileReqParams.emailMas || "none",
        phoneMas: fileReqParams.phoneMas || "none",
        countryMas: fileReqParams.countryMas || "none",
        signUsageMas: fileReqParams.signUsageMas || "none",
        signDimensionMas: fileReqParams.signDimensionMas || "none",
        quantityMas: fileReqParams.quantityMas || "none",
        expectedDeliveryTimeMas: fileReqParams.expectedDeliveryTimeMas || "none",
        budgetIdeaMas: fileReqParams.budgetIdeaMas || "none",
        otherDetailsMas: fileReqParams.otherDetailsMas || "none"
    };

    console.log("qiutd0---fileReqParams:", InfoReqParams);

    try {
        const response = await fetch(ipUrl, {
            method: "POST",
            body: JSON.stringify(InfoReqParams),
        });
        // 如果响应状态码不是 2xx，则抛出异常
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        // 获取响应数据
        const data = await response.json();
        console.log("qiu--->clientsMessageUpdate:", data);

    } catch (error) {
        console.log("clientsMessageUpdate Error:", error);
    }
}


// B. 主页面按钮监听（Submit）
function setupMainButtonListener() {
    document.body.addEventListener("click", (event) => {
        const btn = event.target;
        console.log("qtd3点击的按钮:", btn);

        if (btn.tagName === "BUTTON" &&
            btn.type === "submit" &&
            btn.textContent.trim() === "Submit") {

            const fileReqParams = {
                firstNameMas: document.getElementById("mfjfio0hm7r-BkUcSv79m")?.value || "",
                lastNameMas: document.getElementById("-wvHApj2oR9imQPlGLiLk")?.value || "",
                emailMas: document.getElementById("WSp0enlUX02WhWk4gTPJt")?.value || "",
                phoneMas: document.getElementById("YLgjWO1y6NsFY4wBmkFp6")?.value || "",
                countryMas: document.getElementById("0eKnQVHrH7Ip32ITfSy3v")?.value || "",
                signUsageMas: document.getElementById("WPt0lGDmQzVuy_N4Z_AWW")?.value || "",
                signDimensionMas: document.getElementById("b-kK-z52-Y-YquSE4yFRo")?.value || "",
                quantityMas: document.getElementById("U0DsUxxgQDVeW1Bg7GyJm")?.value || "",
                expectedDeliveryTimeMas: document.getElementById("HsOuO3ltsZsF82Or6wo0c")?.value || "",
                budgetIdeaMas: document.getElementById("hzzbdha28VLg20Sjek0DD")?.value || "",
                otherDetailsMas: document.getElementById("uZwjtZxS6jexkRzV6V1fA")?.value || ""
            };


            console.log("主页面表单:", fileReqParams);
            clientsMessageUpdate(fileReqParams);
        }
    });
}

document.addEventListener("DOMContentLoaded", setupMainButtonListener);



// 监听来自 iframe / 子页面的消息
window.addEventListener("message", function(event) {
    // 安全校验：只接受指定来源的消息
    if (event.origin !== "https://form-builder-en.pifyapp.com") return;

    // 打印收到的数据
    console.log("qiu0父页面收到 Pify 表单提交消息 event.data:", event.data);

    // 如果需要，你可以在这里进一步处理"contact us form"
    // 比如把数据发送到 Shopify 后台
    console.log("event.data.message:", event.data.message);
    if (event.data.message === "contact us form") {
        const formData = event.data.data;
        console.log("contact us form表单数据:", formData);
        const result = extractContectFormData(event.data);
        console.log("result:", result);
        clientsMessageUpdate(result);
    }

    if (event.data.message === "Business form") {
        const formData = event.data.data;
        console.log("Business form表单数据:", formData);
        const result = extractBusinessFormData(event.data);
        console.log("result:", result);
        clientsMessageUpdate(result);
    }
}, false);




function extractContectFormData(message) {
    const attrs = message.data.attributes;

    
    const getByType = (type) => attrs.find(a => a.type === type);
    const getByTitle = (title) => attrs.find(a => a.title === title);

    // 1. first name
    let firstNameMas = getByType("fname")?.value || "";

    // 2. last name
    let lastNameMas = getByType("lname")?.value || "";

    // 3. email
    const emailMas = getByType("email")?.value || "";

    // 4. phone + country code
    const phoneAttr = getByType("phone");
    const phoneMas = phoneAttr?.value || "";
    const countryMas = phoneAttr?.countryCode || "";

    // 5. Indoor / Outdoor
    const signUsageMas = getByTitle("Is Your Sign For Indoor Or Outdoor Usage?")?.optionName || "";

    // 6. 预算
    const budgetIdeaMas = getByTitle("Project Budget")?.value || "";

    // 7. 用户填写的留言
    const otherDetailsMas = getByTitle("Tell Us What You Need")?.value || "";

    // 8. 交付时间
    const expectedDeliveryTimeMas = getByTitle("Date")?.value || "";

    // 9. 数量（你提供的 JSON 中没有 quantity，我给你预留变量）
    const quantityMas = getByTitle("Quantity")?.value || "";

    // 10. 尺寸（你提供的 JSON 中也没尺寸字段，我也给你预留）
    const signDimensionMas = getByTitle("Sign Dimension")?.value || "";

    const addressAttr = getByType("address");

    if (addressAttr?.value) {
        firstNameMas = addressAttr.value.firstName || firstNameMas;
        lastNameMas = addressAttr.value.lastName || lastNameMas;                  
    }

    console.log("主页面表单:", {
        firstNameMas,
        lastNameMas,
        emailMas,
        phoneMas,
        countryMas,
        signUsageMas,
        signDimensionMas,
        quantityMas,
        expectedDeliveryTimeMas,
        budgetIdeaMas,
        otherDetailsMas
    });

    return {
        firstNameMas,
        lastNameMas,
        emailMas,
        phoneMas,
        countryMas,
        signUsageMas,
        signDimensionMas,
        quantityMas,
        expectedDeliveryTimeMas,
        budgetIdeaMas,
        otherDetailsMas
    };
}


function extractBusinessFormData(message) {
    const attrs = message.data.attributes;

    const getByType = (type) => attrs.find(a => a.type === type);
    const getByTitle = (title) => attrs.find(a => a.title === title);
    const getByCode = (code) => attrs.find(a => a.code === code);

    // 1. first name
    let firstNameMas = getByType("fname")?.value || "";

    // 2. last name
    let lastNameMas = getByType("lname")?.value || "";

    // 3. email
    const emailMas = getByType("email")?.value || "";

    // 4. phone & country code
    const phoneMas = getByType("phone")?.value || "";

    const countryMas = getByType("phone")?.countryCode || "";

    // 5. Indoor / Outdoor
    const signUsageMas = getByTitle("Is Your Sign For Indoor Or Outdoor Usage?")?.optionName || "";

    // 6. Sign Dimension
    const signDimensionMas = getByTitle("Size (Width × Height )")?.value || getByCode("8d7642e1-93d0-4fba-8a72-af92d02e2267")?.value || "";

    // 7. Quantity
    const quantityMas = getByTitle("Quantity")?.value  || "";

    // 8. Expected Delivery Time
    const expectedDeliveryTimeMas = getByTitle("Date")?.value || "";

    // 9. Budget
    const budgetIdeaMas = getByTitle("Project Budget")?.value || "";

    // 10. Leave Word
    const otherDetailsMas = getByTitle("Tell Us What You Need")?.value || "";

    const addressAttr = getByType("address");
    
    if (addressAttr?.value) {
        firstNameMas = addressAttr.value.firstName || firstNameMas;
        lastNameMas = addressAttr.value.lastName || lastNameMas;                  
    }

    console.log("另一套表单解析结果:", {
        firstNameMas,
        lastNameMas,
        emailMas,
        phoneMas,
        countryMas,
        signUsageMas,
        signDimensionMas,
        quantityMas,
        expectedDeliveryTimeMas,
        budgetIdeaMas,
        otherDetailsMas
    });

    return {
        firstNameMas,
        lastNameMas,
        emailMas,
        phoneMas,
        countryMas,
        signUsageMas,
        signDimensionMas,
        quantityMas,
        expectedDeliveryTimeMas,
        budgetIdeaMas,
        otherDetailsMas
    };
}

